import { loadPreferences, myPreferences } from '@/appLogic/view/preferences';
import { TableType } from '@/coreDomainsModule/table';
import { INetworkResult } from '@/coreDomainsModule/networkResult';

/**
 * 保持したヘッダー配列を取得する
 */
export class GetTableHeaderPreferenceUseCase {
  /**
   * ヘッダーの配列を取得する
   * @param tableType - テーブルの種類
   * @returns - {headerList: ヘッダーリスト, allHeaderList: 全てのヘッダーリスト（非表示のものも含める）}
   */
  public async Execute(tableType: TableType): Promise<INetworkResult<{ headerList: string[]; allHeaderList: string[] }, Error>> {
    try {
      await loadPreferences();
      if (!myPreferences) {
        return {
          status: {
            type: 'error',
            error: Error('preferenceの取得に失敗しました'),
          },
        };
      }

      if (!Object.keys(myPreferences).includes(tableType) || !myPreferences[tableType].tableHeaderList) {
        return {
          status: {
            type: 'error',
            error: Error('指定したtableTypeのヘッダー情報が存在しません'),
          },
        };
      }

      // 要素の表示/非表示の対応
      const allHeaderList = myPreferences[tableType].tableHeaderList;
      const hideHeaderList = myPreferences[tableType].hideHeaderList;
      const headerList = allHeaderList.filter((header) => {
        return !hideHeaderList.includes(header);
      });

      return {
        status: {
          type: 'success',
          data: { headerList: headerList, allHeaderList: allHeaderList },
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
